import ApiServer from "../ApiServer.js";
import FizConfig from "../FizConfig.js";
import * as FwDatas from "../FwDatas.ts";
import * as amplify from "../util/amplify.ts";
import {BaseCache,SyncCache, TranslationCache} from "../lib/SyncCache.ts";
import { protoExtend } from "../lib/ObjectUtil.js";

import {TaskCache,TaskCategoryCache,TaskListCache} from "./objects/TaskBeans.ts"  
var 
  calendarList,
  calendarByid;


ApiServer.evtcallist = ApiServer.evtcallist.prepare(true,true,true,true,true,true,function(res){
  calendarList = [].concat(res.mine).concat(res.external?res.external:[]).concat(res.families).concat(res.timetables).concat(res.budgets).filter(cal=>cal!==undefined);
  calendarByid = {};
  res.activatedIds = [];
  res.googles.concat(res.outlooks).forEach(credential=>{
    calendarList = calendarList.concat(credential.linked);
    credential.linked.forEach(cal=>{
      cal.rights.canShare = true;
    });
  });
  if(res.external){
    res.external.forEach(cal=>{
      cal.rights.canShare = true;
    });
  }
  calendarList.forEach(cal=>{
    calendarByid[cal.metaId] = cal;
    if(cal.activated && !cal.calendars){
      res.activatedIds.push(cal.metaId) 
    }
    if(cal.calendars){
      cal.calendars.forEach(subCalendar=>{
        calendarList.push(subCalendar)
        calendarByid[subCalendar.metaId] = subCalendar
        if(cal.activated && subCalendar.activated){
          res.activatedIds.push(subCalendar.metaId) 
        }
      })
    }
  });
  //TODO verify if this this list is used and if not remove it
  res.list = calendarList;
  res.byId = calendarByid;
  return res;
})

class CalListCacheClass extends BaseCache{
  constructor(){
    super(ApiServer.evtcallist)
    this.syncCacheById = {};
  }
  //get an element in the current cache out of date or not
  getCache(metaId){
    if(!this.syncCacheById[metaId]){
      if(metaId.indexOf('calendarFolder/')===0 || metaId.indexOf('calendarFolderOtherFamilies/')===0){
        this.syncCacheById[metaId] = new BaseCache(function(eventConsumer,errorHandler){this.datas = [],eventConsumer(this.datas)})
      }else if(metaId.indexOf('calendarTask/')===0){
        this.syncCacheById[metaId] = buildTaskAsEventCache(metaId)
      }else{
        this.syncCacheById[metaId] = new SyncCache(ApiServer.evtsync.prepare(null,null,metaId))
      }
    }
    return this.syncCacheById[metaId];
  }
}

function buildTaskAsEventCache(calendarId){
  return new TranslationCache(TaskCache,async function(tasks){
    const
      result = [];

    tasks.forEach((task)=>{
      if(task.dueDate){
        var extension = {
          isAttendee(accountId){
            return this.assignee.find((assignee)=>{
              return accountId===assignee.accountId;
            })!==undefined;
          },
          attendeeIds:task.assignee.map(assignee=>assignee.accountId),
          calendarId
        };
        //taskAsEvent.metaId = task.metaId.replace('task/','taskAsEvent/')
        if(task.assignee.length===1){
          extension.colorDB = task.assignee[0].color
        }
        extension.calendarId = calendarId;
        extension.draggable = task.editable;
        //disable drag n drop for recurring task
        if(task.recurrencyDescriptor.recurrency!=='NONE'){
          extension.draggable = false;
        }
        extension.isTaskEvent = true;
        result.push(protoExtend(task,extension));
      }
    });
    return result;
  })
  
}

const CalListCache = new CalListCacheClass();

const EventStore = {
  invalidate(calendarIdFilter=(t=>true)){
    Object.entries(CalListCache.syncCacheById).forEach(([key,value])=>{
      if(calendarIdFilter(key)){
        value.invalidate()
      }
    })
  },
  async getSelectedCalendarIds(){
    return CalListCache.need().then(calendarBean=>{
      return calendarBean.activatedIds
    })
  },
  /**
   * 
   * @param {*} selectedCalendarIds 
   * @returns Promise<IEvent[]>
   */
  async getFor(selectedCalendarIds){
    if(!selectedCalendarIds) {
      selectedCalendarIds = await this.getSelectedCalendarIds()
    }
    
    ApiServer.setGroupOptions({timeout:60000}); //30sec for calendar instead of 20s because of a user who has 13000 event
    
    return Promise.all(
      selectedCalendarIds.map(calendarId=>CalListCache.getCache(calendarId).need())
    ).then(function(arrayOfArray){
      var result = arrayOfArray.flat()
      result.forEach(event=>{
        event.calendar = calendarByid[event.calendarId];
      })
      return result;
    })
  },
  loadEventsBySync(selectedCalendarIds,selectedMembersIds,range){
    return this.getFor(selectedCalendarIds).then(function (allevents){
        var 
          intervalEvent = [];
        allevents.forEach((event)=>{
          //handle the filter of attendee
          if(selectedMembersIds.length>0){
            if(selectedMembersIds.find(memberId=>event.isAttendee(memberId))===undefined){
              return;
            }
          }
          event.listInterval(range).forEach(eventInstance=>{
            FwDatas.cache(eventInstance)
            intervalEvent.push(eventInstance);
            eventInstance.colorUI = eventInstance.color = (event.colorDB || event.colorAttendee || event.calendar.color || FizConfig.defaultColor);
          });
        });
        return intervalEvent;
         
    }); 
  }
}
//this is only for the color
amplify.subscribe("familyScopeChange",function(){EventStore.invalidate();});

export {CalListCache,EventStore};